import React, { useState, useEffect, Fragment } from 'react';
import ModalSortDescription from '../modal/ModalSortDescription';
import ModalNouveauSort from '../modal/ModalNouveauSort';
import ModalSortLvlUp from '../modal/ModalSortLvlUp';
const Spells = ({ spells, idPerso,token }) => {
  const [sortsCourant, setSortsCourants] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalNewOpen, setIsModalNewOpen] = useState(false);
  const [isModalNewLvlOpen, setIsModalNewLvlOpen] = useState(false);
  const [selectedSpell, setSelectedSpell] = useState(null);
  const [modif, setModif] = useState(false);
  useEffect(() => {
    if(modif) {
      setIsModalNewOpen(true)
    }else{
      setSelectedSpell(null)
    }
}, [modif,isModalNewLvlOpen]);
  useEffect(() => {
    const transformedData = Object.entries(spells[0]).reduce((acc, [nom, levels]) => {
      const niveau = Object.keys(levels).sort()[0]; // Obtenir le plus bas niveau (premier niveau)
      acc[nom] = niveau;
      return acc;
    }, {});

    setSortsCourants(transformedData);
  }, [spells]);

  const handleSortLvlChange = (value, nom) => {
    if (value === "+") {
      setIsModalOpen(true);
    } else {
      setSortsCourants(prev => {
        const temp = { ...prev }
        temp[nom] = value
        return temp
      })
      setSelectedSpell(spells[0][nom][value])
    }
  };

  return (
    <div className="table__wrap table_wrap">
      <table className="table">
        <thead className="table__header">
        </thead>

        <tbody>
          {Object.entries(sortsCourant).map(([nom, niveau]) => {
            const spell = spells[0][nom][niveau];
            return (
              <tr className="table__row2" id={nom} key={nom} onClick={() => { setSelectedSpell(spell); setIsModalOpen(!isModalOpen) }}>
                <td id={nom} className="table__account table__cell">
                  <div className="table__account-content">
                    <span className="table__account-number" id={nom}>{spell.nom}</span>
                  </div>
                </td>
                <td id={nom} className="table__account table__cell">
                  <span className="table__account-number" id={nom}>{spell.effet}</span>
                </td>
                <td id={nom} className="table__balance table__cell u-font-mono">
                  <span className="num_negative" id={nom}>{spell.cout}</span>
                </td>
                <td id={nom} className="table__lvl table__cell u-font-mono">
                  <span className="num_negative" id={nom}>Niveau : {spell.niveau}</span>
                </td>
              </tr>
            );
          })}

          <tr className="table__row1_button">
            <td className='center' colspan="4">
              <button
                className='pushable ajout_tabs'
                onClick={() => { setIsModalNewOpen(true) }}
              >
                <span id="Force" className="front front_add" >
                  Ajout nouveau sort
                </span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      {selectedSpell && (<Fragment>     
          <ModalSortDescription
            isOpen={isModalOpen}
            changeLvl={handleSortLvlChange}
            spell={selectedSpell}
            dropdown={spells[0][selectedSpell.nom]}
            setOpen={setIsModalOpen}
            setModif={setModif}
            setIsModalNewOpen={setIsModalNewLvlOpen}
            token={token}
          />
          <ModalSortLvlUp
          isOpen={isModalNewLvlOpen}
          idPerso={idPerso}
          setOpen={setIsModalNewLvlOpen}
          spell={selectedSpell}
          token={token}
        />
      </Fragment>
      )}
      <ModalNouveauSort
        isOpen={isModalNewOpen}
        idPerso={idPerso}
        setOpen={setIsModalNewOpen}
        sort={modif ? selectedSpell: null}
        setModif={setModif}
        token={token}
      />
    </div>
  );
};


export default Spells;
